// Persistence for the "hide the create new button" flag.
//
// Sugar is the master of the setting: HIDE_NEW_BUTTON_TECHNICIAN=1 hides the button for
// users with the technician role, and sugar reports the result as hideNewButton through
// the iframe message ~1 s after every page load. Until then the last known value is
// used, so the button does not flash into view on every load.
//
// sessionStorage on purpose: the flag follows the tab and the logged in user, and a
// stale value cannot outlive the browser session.

const KEY = 'hideNewButton';

const parse = (raw) => {
    if (raw === 'true' || raw === '1') {
        return true;
    }
    if (raw === 'false' || raw === '0') {
        return false;
    }
    return null;
}

/**
 * The last known setting, or null when nothing has been stored yet.
 *
 * @returns {boolean|null}
 */
export const readStoredHideNewButton = () => {
    try {
        return parse(window.sessionStorage.getItem(KEY));
    } catch (e) {
        return null;
    }
}

/**
 * The setting to render with before sugar has had a chance to report anything.
 * Defaults to false (button visible).
 *
 * @returns {boolean}
 */
export const resolveInitialHideNewButton = () => readStoredHideNewButton() === true;

/**
 * Remember the setting.
 *
 * @param {boolean} value
 */
export const writeHideNewButton = (value) => {
    try {
        window.sessionStorage.setItem(KEY, value ? 'true' : 'false');
    } catch (e) {
        // ignore
    }
}
